import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./core/components/nx-main/main.routes').then((mod) => mod.MAIN_ROUTES)
  }
];
